import { render, staticRenderFns } from "./SIM-Card.vue?vue&type=template&id=348b495a&scoped=true&"
import script from "./SIM-Card.vue?vue&type=script&lang=js&"
export * from "./SIM-Card.vue?vue&type=script&lang=js&"
import style0 from "./SIM-Card.vue?vue&type=style&index=0&id=348b495a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b495a",
  null
  
)

export default component.exports